import Box from "@mui/material/Box";
import colorConfigs from "../../../configs/colorConfigs";
import CheckIcon from '@mui/icons-material/Check';
import { flexRender } from "material-react-table";


const StepCard = ({ data }: any) => {

  const { state, title } = data;

  return (

    <Box sx={{ display: "flex", maxWidth: '140px', my: "20px", justifyContent: "center" , opacity: state ==="incomplete"? 0.3 : 1}}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 20,
          display: "flex",
          mr: '10px',
          bgcolor: colorConfigs.btnColor.bgColorLightBlue,
        }}
      >
        {state === "completed" &&
          <CheckIcon
            sx={{
              color: colorConfigs.btnStyle.color,
              fontSize: "34px",
              justifyContent: "center",
              display: "flex",
              alignContent: "center",
              margin: "auto"
            }}
            className="" />}
      </Box>
      <Box sx={{ alignSelf: "center" }}>
        {title}
      </Box>
    </Box>

  )

}

export default StepCard;